import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { DashboardMetricItemData } from '@utils/dashboardMetrics.util'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import {
  FinanceMetricTileFromData,
  FinanceMetricTileItem,
} from '../../FinanceMetricTiles.component'

type ProductionPerHygieneVisitCardProps = {
  titleHref: string
  metric: DashboardMetricItemData | undefined
  loading?: boolean
  /** Hygiene response has arrived (`data != null`). */
  hasPayload: boolean
  /** Production per hygiene visit is a finite nonzero value. */
  hasData: boolean
  className?: string
}

export function ProductionPerHygieneVisitCard({
  titleHref,
  metric,
  loading = false,
  hasPayload,
  hasData,
  className,
}: ProductionPerHygieneVisitCardProps): React.ReactElement {
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Production per hygiene visit"
      titleHref={titleHref}
      className={['dashboard-finance-hygiene-card', className]
        .filter(Boolean)
        .join(' ')}
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      {metric ? (
        <FinanceMetricTileFromData {...metric} />
      ) : (
        <FinanceMetricTileItem
          leftLabel="Production per hygiene visit"
          value={HYGIENE_PLACEHOLDER}
        />
      )}
    </DashboardSectionCard>
  )
}
